<template>
  <div v-if="pagination && pagination.lastPage > 1" class="tt-pagination">
    <button
      class="btn btn-sm tt-btn-ghost"
      :disabled="pagination.currentPage <= 1"
      @click="$emit('page', pagination.currentPage - 1)"
    >
      Prev
    </button>
    <span class="small text-muted">Page {{ pagination.currentPage }} of {{ pagination.lastPage }}</span>
    <button
      class="btn btn-sm tt-btn-ghost"
      :disabled="pagination.currentPage >= pagination.lastPage"
      @click="$emit('page', pagination.currentPage + 1)"
    >
      Next
    </button>
  </div>
</template>

<script>
export default {
  name: "TripPagination",
  props: {
    pagination: { type: Object, default: null },
  },
};
</script>
